var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueSelect',{attrs:{"options":_vm.options,"get-option-label":_vm.getOptionLabel,"value":_vm.value,"filterable":false,"multiple":true},on:{"search":_vm.onSearch,"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }